import { PlanStatusEnum } from 'APIPackage/PlanListModule/enums/PlanStatusEnum';

const map: Record<string, PlanStatusEnum> = {
  Новый: PlanStatusEnum.NEW,
  Согласован: PlanStatusEnum.AGREED,
  Утверждён: PlanStatusEnum.APPROVED,
  'На согласовании': PlanStatusEnum.IN_AGREEMENT,
  'На доработке': PlanStatusEnum.IN_REVISION,
};

export function getErpPlanLabel(status: PlanStatusEnum) {
  return Object.keys(map).find(key => map[key] === status);
}
